import { useTranslation } from 'react-i18next';

import { usePsapConfiguration } from '@/app/shell/psapConfiguration';
import { LanguageSelector, NgPageHeader } from '@/ui';

import { PushSubscription } from './PushSubscription';
import { hasEnabledPushNotifications } from './pushNotificationTypes';
import type { PushNotificationConfiguration } from './pushNotificationTypes';

export function SettingsPage() {
  const { t } = useTranslation();
  const psapConfiguration = usePsapConfiguration();
  const pageTitle = t('PageTitle_Settings');

  const pushNotificationConfiguration = psapConfiguration.notificationConfiguration
    ?.pushNotificationConfiguration as PushNotificationConfiguration | null | undefined;

  return (
    <div className="content p-3">
      <NgPageHeader title={pageTitle} />
      <h1 className="mb-4">{pageTitle}</h1>

      <div className="d-flex flex-column gap-4">
        <div>
          <LanguageSelector />
        </div>

        {hasEnabledPushNotifications(pushNotificationConfiguration) && (
          <div>
            <PushSubscription configuration={pushNotificationConfiguration} />
          </div>
        )}
      </div>
    </div>
  );
}
